package com.devi3east.bashbuddy.footer.requests

import kotlinx.serialization.Serializable

@Serializable
data class ContactFormRequest(
    val name: String,
    val email: String,
    val phone: String?,
    val message: String
)